// Please keep constants alphabetized
export const attributes = {
  ACCEPT: 'accept',
  ACTION: 'action',
  ACTIONABLE: 'actionable',
  ACTIVE: 'active',
  ACTIVATED: 'activated',
  ADD_NEW_AT_END: 'add-new-at-end',
  ADVANCED: 'advanced',
  ALERT: 'alert',
  ALIGN: 'align',
  ALIGN_CONTENT: 'align-content',
  ALIGN_EDGE: 'align-edge',
  ALIGN_ITEMS: 'align-items',
  ALIGN_SELF: 'align-self',
  ALIGN_TARGET: 'align-target',
  ALIGN_X: 'align-x',
  ALIGN_X_LABELS: 'align-x-labels',
  ALIGN_Y: 'align-y',
  ALLOW_BLANK: 'allow-blank',
  ALLOW_EMPTY_HREF: 'allow-empty-href',
  ALLOW_LINK: 'allow-link',
  ALLOW_ONE_PANE: 'allow-one-pane',
  ALLOW_ONE_EXPANDED_ROW: 'allow-one-expanded-row',
  ALWAYS_SHOW_EXPAND_BUTTON: 'always-show-expand-button',
  ALT: 'alt',
  ALTERNATE_ROW_SHADING: 'alternate-row-shading',
  ANIMATED: 'animated',
  ANIMATION_SPEED: 'animation-speed',
  ANIMATION_STYLE: 'animation-style',
  APP_NAME: 'app-name',
  APPEARANCE: 'appearance',
  ARROW: 'arrow',
  ARROW_TARGET: 'arrow-target',
  AS_NAV: 'as-nav',
  ATTACHMENT: 'attachment',
  AUDIBLE: 'audible',
  AUTO: 'auto',
  AUTO_FILL: 'auto-fill',
  AUTO_FIT: 'auto-fit',
  AUTO_FLOW: 'auto-flow',
  AUTO_FOCUS: 'auto-focus',
  AUTO_HEIGHT: 'auto-height',
  AUTO_ROWS: 'auto-rows',
  AUTO_SIZE: 'auto-size',
  AUTO_START: 'auto-start',
  AUTOCOMPLETE: 'autocomplete',
  AUTOGROW: 'autogrow',
  AUTOSELECT: 'autoselect',
  AUTOOPEN: 'autoopen',
  AUTOUPDATE: 'autoupdate',
  AXIS: 'axis',
  AXIS_FORMATTER: 'axis-formatter',
  AXIS_LABEL_BOTTOM: 'axis-label-bottom',
  AXIS_LABEL_END: 'axis-label-end',
  AXIS_LABEL_MARGIN: 'axis-label-margin',
  AXIS_LABEL_START: 'axis-label-start',
  AXIS_LABEL_TOP: 'axis-label-top',
  BACKGROUND_COLOR: 'background-color',
  BADGE: 'badge',
  BADGE_COLOR: 'badge-color',
  BADGE_POSITION: 'badge-position',
  BAR_PERCENTAGE: 'bar-percentage',
  BG_TRANSPARENT: 'bg-transparent',
  BLEED: 'bleed',
  BLEED_X: 'bleed-x',
  BLEED_Y: 'bleed-y',
  BOLD: 'bold',
  BORDERED: 'bordered',
  BORDER_RADIUS: 'border-radius',
  BORDERLESS: 'borderless',
  BOTTOM: 'bottom',
  BREAKPOINT: 'breakpoint',
  BROWSER_AUTOCOMPLETE: 'browser-autocomplete',
  BUFFER_SIZE: 'buffer-size',
  BUTTON: 'button',
  BUTTON_TEXT: 'button-text',
  BUTTONS: 'buttons',
  CANCEL: 'cancel',
  CANCEL_BTN_TEXT: 'cancel-btn-text',
  CAPS_LOCK: 'caps-lock',
  CAPTURES_FOCUS: 'captures-focus',
  CATEGORY: 'category',
  CATEGORY_PERCENTAGE: 'category-percentage',
  CELL_COPY_PASTE: 'cell-copy-paste',
  CENTER_ON_OVERFLOW: 'center-on-overflow',
  CELL_SELECTION: 'cell-selection',
  CHAR_MAX_TEXT: 'char-max-text',
  CHAR_REMAINING_TEXT: 'char-remaining-text',
  CHARACTER_COUNTER: 'character-counter',
  CHECKED: 'checked',
  CHILD_FILTER_MATCH: 'child-filter-match',
  CLEARABLE: 'clearable',
  CLEARABLE_FORCED: 'clearable-forced',
  CLEARABLE_TEXT: 'clearable-text',
  CLICK_OUTSIDE_TO_CLOSE: 'click-outside-to-close',
  CLICKABLE: 'clickable',
  CLOSE_LABEL_AUDIBLE: 'close-label-audible',
  CLOSE_ON_SCROLL: 'close-on-scroll',
  COL_END: 'col-end',
  COL_END_LG: 'col-end-lg',
  COL_END_MD: 'col-end-md',
  COL_END_SM: 'col-end-sm',
  COL_END_XL: 'col-end-xl',
  COL_END_XS: 'col-end-xs',
  COL_END_XXL: 'col-end-xxl',
  COL_GAP: 'col-gap',
  COL_SELECTION: 'col-selection',
  COLSPAN: 'colspan',
  COL_SPAN: 'col-span',
  COL_SPAN_LG: 'col-span-lg',
  COL_SPAN_MD: 'col-span-md',
  COL_SPAN_SM: 'col-span-sm',
  COL_SPAN_XL: 'col-span-xl',
  COL_SPAN_XS: 'col-span-xs',
  COL_SPAN_XXL: 'col-span-xxl',
  COL_START: 'col-start',
  COL_START_LG: 'col-start-lg',
  COL_START_MD: 'col-start-md',
  COL_START_SM: 'col-start-sm',
  COL_START_XL: 'col-start-xl',
  COL_START_XS: 'col-start-xs',
  COL_START_XXL: 'col-start-xxl',
  COLLAPSED: 'collapsed',
  COLLAPSIBLE: 'collapsible',
  COLLAPSIBLE_RESPONSIVE: 'collapsible-responsive',
  COLLAPSE_ICON: 'collapse-icon',
  COLLAPSE_CHILDREN: 'collapse-children',
  COLOR: 'color',
  COLOR_VARIANT: 'color-variant',
  COLS: 'cols',
  COLS_LG: 'cols-lg',
  COLS_MD: 'cols-md',
  COLS_SM: 'cols-sm',
  COLS_XL: 'cols-xl',
  COLS_XS: 'cols-xs',
  COLS_XXL: 'cols-xxl',
  COLUMN_ID: 'column-id',
  COLUMNS: 'columns',
  COMBOBOX: 'combobox',
  COMPACT: 'compact',
  COMPLETED_LABEL: 'completed-label',
  COMPONENT_NAME: 'component-name',
  CONDITION: 'condition',
  CONFIRM: 'confirm',
  CONTAINED: 'contained',
  CONTAINER_TARGET: 'container-target',
  CONTENT_ALIGN: 'content-align',
  COPYRIGHT_YEAR: 'copyright-year',
  COUNT: 'count',
  CSS_CLASS: 'css-class',
  CURSOR: 'cursor',
  CYCLES_FOCUS: 'cycles-focus',
  DATA: 'data',
  DATA_ACTION: 'data-action',
  DATA_FILTER_TYPE: 'data-filter-type',
  DATA_ID: 'data-id',
  DATA_INDEX: 'data-index',
  DATA_COLLAPSED: 'data-collapsed',
  DATA_VALUE: 'data-value',
  DATA_OG_COLOR: 'data-original-color',
  DATE: 'date',
  DAY: 'day',
  DEFAULT_EXPANDED_INDEX: 'default-expanded-index',
  DELAY: 'delay',
  DELIMITER: 'delimiter',
  DESCRIBED_BY: 'describedby',
  DESCRIPTION: 'description',
  DEVICE_SPECS: 'device-specs',
  DIRECTION: 'direction',
  DIRTY_TRACKER: 'dirty-tracker',
  DISABLE_CLIENT_FILTER: 'disable-client-filter',
  DISABLE_CLIENT_SORT: 'disable-client-sort',
  DISABLE_EVENTS: 'disable-native-events',
  DISABLE_ERROR: 'disable-error',
  DISABLE_ICON: 'disable-icon',
  NO_AUTO_TOGGLE: 'no-auto-toggle',
  DISABLE_ROW_HIGHLIGHT: 'disable-row-highlight',
  DISABLE_AUTO_COLLAPSE: 'disable-auto-collapse',
  DISABLE_TOOLTIP: 'disable-tooltip',
  DISABLE_HEADER_CHECKBOX: 'disable-header-checkbox',
  DISABLE_MOBILE_ZOOM: 'disable-mobile-zoom',
  DISABLED: 'disabled',
  DISMISSIBLE: 'dismissible',
  DISPLAY: 'display',
  DISPLAY_COMMENTS: 'display-comments',
  DISPLAY_MODE: 'display-mode',
  DISPLAY_SELECTED_TEXT: 'display-selected-text',
  DISPLAY_TIME: 'display-time',
  DIVIDER: 'divider',
  DONUT: 'donut',
  DOT_RADIUS: 'dot-radius',
  DONUT_TEXT: 'donut-text',
  DRAG_MODE: 'drag-mode',
  DRAGGABLE: 'draggable',
  DRAGGING: 'dragging',
  DRAG_WIDTH: 'drag-width',
  DRAG_HEIGHT: 'drag-height',
  DRAG_BG_COLOR: 'drag-bg-color',
  DROPPED: 'dropped',
  DROP_WIDTH: 'drop-width',
  DROP_HEIGHT: 'drop-height',
  DROP_BG_COLOR: 'drop-bg-color',
  DROP_TARGET: 'drop-target',
  DROPDOWN_ICON: 'dropdown-icon',
  EDGE: 'edge',
  EDIT_NEXT_ON_ENTER_PRESS: 'edit-next-on-enter-press',
  ESCALATED: 'escalated',
  EDITABLE: 'editable',
  EDITING: 'editing',
  EDITOR_ACTION: 'editor-action',
  EMBEDDABLE: 'embeddable',
  EMBEDDED: 'embedded',
  EMPTY_MESSAGE_DESCRIPTION: 'empty-message-description',
  EMPTY_MESSAGE_ICON: 'empty-message-icon',
  EMPTY_MESSAGE_LABEL: 'empty-message-label',
  ENABLE_CONTAINER: 'enable-container',
  ENABLE_HOVER_CHANGE: 'enable-hover-change',
  END_DATE: 'end-date',
  END_HOUR: 'end-hour',
  ERROR: 'error',
  ERROR_MESSAGE: 'error-message',
  ERROR_TRACKER: 'error-tracker',
  EVENT_DEBOUNCE: 'event-debounce',
  EVENT_TYPE_ID: 'event-type-id',
  EXPAND_ICON: 'expand-icon',
  EXPAND_STYLE: 'expand-style',
  EXPAND_TARGET: 'expand-target',
  EXPANDABLE_ROW: 'expandable-row',
  EXPANDABLE_ROW_TEMPLATE: 'expandable-row-template',
  EXPANDED: 'expanded',
  EXPANDED_WIDTH: 'expanded-width',
  EXPANDER_TYPE: 'expander-type',
  FALLBACK: 'fallback',
  FAVOR: 'favor',
  FIELD: 'field',
  FIELD_HEIGHT: 'field-height',
  FIELD_INDICATOR: 'field-indicator',
  FIELD_INDICATOR_MESSAGE: 'field-indicator-message',
  FILE: 'file',
  FILE_NAME: 'file-name',
  FILL: 'fill',
  FIXED_WEEKS: 'fixed-weeks',
  FILTER_ROW_DISABLED: 'filter-row-disabled',
  FILTER_WHEN_TYPING: 'filter-when-typing',
  FILTER_TYPE: 'filter-type',
  FILTERABLE: 'filterable',
  FIRST: 'first',
  FIRST_DAY_OF_WEEK: 'first-day-of-week',
  FIRST_DRAGGABLE_COLUMN: 'first-draggable-column',
  FIXED: 'fixed',
  FLEX: 'flex',
  FLEX_GROW: 'flex-grow',
  FLEX_SHRINK: 'flex-shrink',
  FLOW: 'flow',
  FLOW_LG: 'flow-lg',
  FLOW_MD: 'flow-md',
  FLOW_SM: 'flow-sm',
  FLOW_XL: 'flow-xl',
  FLOW_XS: 'flow-xs',
  FLOW_XXL: 'flow-xxl',
  FOCUS_INLINE: 'focus-inline',
  FOCUSABLE: 'focusable',
  FOCUS_TARGET: 'focus-target',
  FONT_SIZE: 'font-size',
  FONT_WEIGHT: 'font-weight',
  FORMAT: 'format',
  FORMATTER_WIDTH: 'formatter-width',
  FULL_HEIGHT: 'full-height',
  FULLSIZE: 'fullsize',
  GAP: 'gap',
  GAP_X: 'gap-x',
  GAP_Y: 'gap-y',
  GENERATIVE_AI: 'generative-ai',
  GROUP: 'group',
  GROUP_DISABLED: 'group-disabled',
  GROUP_EVENTS: 'group-events',
  GROUP_LABEL: 'group-label',
  GROUP_SELECTS_CHILDREN: 'group-selects-children',
  GROUPABLE: 'groupable',
  GROUPED: 'grouped',
  GROW: 'grow',
  HANDLE: 'handle',
  HAS_ERROR: 'has-error',
  HEADER_FILL: 'header-fill',
  HEADER_MENU_ID: 'header-menu-id',
  HEADER_OPACITY_VALUE: 'header-opacity-value',
  HEIGHT: 'height',
  HEX: 'hex',
  HIDDEN: 'hidden',
  HIDDEN_BY_FILTER: 'hidden-by-filter',
  HIDE: 'hide',
  HIDE_HEADER_CHECKBOX: 'hide-header-checkbox',
  HIDE_HEADERS: 'hide-headers',
  HIDE_CHECKBOXES: 'hide-checkboxes',
  HIDE_DOWN: 'hide-down',
  HIDE_FOCUS: 'hide-focus',
  HIDE_ON_ONE: 'hide-on-one',
  HIDE_UP: 'hide-up',
  HIGHLIGHTED: 'highlighted',
  HITBOX: 'hitbox',
  HORIZONTAL: 'horizontal',
  HORIZONTAL_ALIGNED: 'horizontal-aligned',
  HOURS: 'hours',
  HREF: 'href',
  HYPERLINK_BEHAVIOR: 'hyperlink-behavior',
  ICON: 'icon',
  ICON_ALIGN: 'icon-align',
  ICON_OFF: 'icon-off',
  ICON_ON: 'icon-on',
  ICON_SIZE: 'icon-size',
  ID: 'id',
  ID_COLUMN: 'id-column',
  INACTIVE: 'inactive',
  INDETERMINATE: 'indeterminate',
  INDEX: 'index',
  INFO_FIELD: 'info-field',
  INHERIT_COLOR: 'inherit-color',
  INERT: 'inert',
  INITIALS: 'initials',
  INLINE: 'inline',
  INPUT_AUTO_SIZE: 'input-auto-size',
  IS_CALENDAR_TOOLBAR: 'is-calendar-toolbar',
  IS_DATEPICKER: 'is-date-picker',
  IS_DRAGGING: 'is-dragging',
  IS_DROPDOWN: 'is-dropdown',
  ITEM_HEIGHT: 'item-height',
  JUSTIFY: 'justify',
  JUSTIFY_CONTENT: 'justify-content',
  KEEP_FILTER_CONDITIONS: 'keep-filter-conditions',
  KEEP_OPEN: 'keep-open',
  KEEP_OPEN_WITH_VALUE: 'keep-open-with-value',
  KEEP_EXPANDER_PLACEMENT: 'keep-expander-placement',
  KPI: 'kpi',
  KPI_FORMAT: 'kpi-format',
  LABEL: 'label',
  LABEL_ALIGN: 'label-align',
  LABEL_ALIGN_Y: 'label-align-y',
  LABEL_ALIGNMENT: 'label-alignment',
  LABEL_AUDIBLE: 'label-audible',
  LABEL_BREAK: 'label-break',
  LABEL_COLOR: 'label-color',
  LABEL_FILETYPE: 'label-filetype',
  LABEL_HIDDEN: 'label-hidden',
  LABEL_OFFSET: 'label-offset',
  LABEL_POSITION: 'label-position',
  LABEL_PROGRESS: 'label-progress',
  LABEL_REQUIRED: 'label-required',
  LABEL_SECONDARY: 'label-secondary',
  LABEL_STATE: 'label-state',
  LABEL_TOTAL: 'label-total',
  LABEL_WIDTH: 'label-width',
  LABEL_WRAP: 'label-wrap',
  LABEL_FACTOR: 'label-factor',
  LANGUAGE: 'language',
  LAST: 'last',
  LAZY: 'lazy',
  LAZY_LOAD: 'lazy-load',
  LEGEND_PLACEMENT: 'legend-placement',
  LEVELS: 'levels',
  LINE_CLAMP: 'line-clamp',
  LINEAR: 'linear',
  LINK: 'link',
  LINK_TEXT: 'link-text',
  LIST: 'list',
  LIST_BOX_POSITION_STYLE: 'list-box-position-style',
  LIST_STYLE: 'list-style',
  LOADED: 'loaded',
  LOADING: 'loading',
  LOADING_INDICATOR_ONLY: 'loading-indicator-only',
  LOCALE: 'locale',
  LOCALE_MENU: 'locale-menu',
  LOOP: 'loop',
  LOWERCASE: 'lowercase',
  MAIN_LABEL: 'main-label',
  MARGIN: 'margin',
  MARGIN_BLOCK_END: 'margin-block-end',
  MARGIN_BLOCK_START: 'margin-block-start',
  MARGIN_INLINE_END: 'margin-inline-end',
  MARGIN_INLINE_START: 'margin-inline-start',
  MARGIN_Y: 'margin-y',
  MARGINS: 'margins',
  MARKER_SIZE: 'marker-size',
  MASK: 'mask',
  MASKED: 'masked',
  MASK_GUIDE: 'mask-guide',
  MASK_OPTIONS: 'mask-options',
  MASK_RETAIN_POSITIONS: 'mask-retain-positions',
  TEXT_MASK_CHARACTER: 'text-mask-character',
  MASK_TYPE: 'mask-type',
  MAX: 'max',
  MAX_COL_WIDTH: 'max-col-width',
  MAX_COLUMNS: 'max-columns',
  MAX_FILE_SIZE: 'max-file-size',
  MAX_FILES: 'max-files',
  MAX_FILES_IN_PROCESS: 'max-files-in-process',
  MAX_HEIGHT: 'max-height',
  MAX_ROW_HEIGHT: 'max-row-height',
  MAX_SIZE: 'max-size',
  MAX_TRANSFORM_X: 'max-transform-x',
  MAX_TRANSFORM_Y: 'max-transform-y',
  MAX_VALUE: 'max-value',
  MAX_WIDTH: 'max-width',
  MAXLENGTH: 'maxlength',
  MENU: 'menu',
  MENU_ID: 'menu-id',
  MESSAGE: 'message',
  MESSAGE_TEXT: 'message-text',
  MESSAGE_TITLE: 'message-title',
  METHOD: 'method',
  MIN: 'min',
  MIN_COL_WIDTH: 'min-col-width',
  MIN_HEIGHT: 'min-height',
  MIN_ROW_HEIGHT: 'min-row-height',
  MIN_SIZE: 'min-size',
  MIN_DISTANCE: 'min-distance',
  MIN_TRANSFORM_X: 'min-transform-x',
  MIN_TRANSFORM_Y: 'min-transform-y',
  MIN_WIDTH: 'min-width',
  MINUTE_INTERVAL: 'minute-interval',
  MINUTES: 'minutes',
  MODE: 'mode',
  MONTH: 'month',
  MORE_ACTIONS: 'more-actions',
  MULTIPLE: 'multiple',
  MULTI_COLUMN: 'multi-column',
  NAME: 'name',
  NAV_DISABLED: 'nav-disabled',
  NEXT: 'next',
  NO_ANIMATION: 'no-animation',
  NO_ARIA_LABEL: 'no-aria-label',
  NO_HEADER: 'no-header',
  NO_MARGINS: 'no-margins',
  NO_PADDING: 'no-padding',
  NO_RESULTS: 'no-results',
  NO_SCROLL: 'no-scroll',
  NO_SEARCH: 'no-search',
  NOTIFICATION_COUNT: 'notification-count',
  NUMBERING_SYSTEM: 'numbering-system',
  OBJECT_FIT: 'object-fit',
  OFFSET_CONTAINER: 'offset-container',
  OFFSET_CONTENT: 'offset-content',
  OPACITY: 'opacity',
  OPACITY_AREA: 'opacity-area',
  OPACITY_CIRCLES: 'opacity-circles',
  OPERATOR: 'operator',
  ORDER: 'order',
  ORDER_LG: 'order-lg',
  ORDER_MD: 'order-md',
  ORDER_SM: 'order-sm',
  ORDER_XL: 'order-xl',
  ORDER_XS: 'order-xs',
  ORDER_XXL: 'order-xxl',
  ORIENTATION: 'orientation',
  ORIGINAL_TEXT: 'original-text',
  OVER: 'over',
  OVERFLOW: 'overflow',
  OVERFLOW_TOOLTIP: 'overflow-tooltip',
  OVERFLOW_WRAP: 'overflow-wrap',
  OVERFLOWED: 'overflowed',
  OVERLAY: 'overlay',
  PADDING: 'padding',
  PADDING_X: 'padding-x',
  PADDING_Y: 'padding-y',
  PAGE_COUNT: 'page-count',
  PAGE_NUMBER: 'page-number',
  PAGE_SIZE: 'page-size',
  PAGE_TOTAL: 'page-total',
  PAGINATION: 'pagination',
  PARAGRAPH_SEPARATOR: 'paragraph-separator',
  PARAM_NAME: 'param-name',
  PARENT_CONTAINMENT: 'parent-containment',
  PARENT_DISABLED: 'parent-disabled',
  PART: 'part',
  PASSWORD_VISIBLE: 'password-visible',
  PASTE_AS_PLAIN_TEXT: 'paste-as-plain-text',
  PERCENT: 'percent',
  PERCENTAGE_VISIBLE: 'percentage-visible',
  PERIOD: 'period',
  PERSIST_EXPANDED: 'persist-expanded',
  KEEP_VISIBLE: 'keep-visible',
  PINNED: 'pinned',
  PINNABLE: 'pinnable',
  PLACEHOLDER: 'placeholder',
  PLACEMENT: 'placement',
  POSITION: 'position',
  POSITION_STYLE: 'position-style',
  PRE_SELECTED: 'preselected',
  PRESSED: 'pressed',
  PREVIOUS: 'previous',
  PRINTABLE: 'printable',
  PRODUCT_NAME: 'product-name',
  PRODUCT_VERSION: 'product-version',
  PROGRESS: 'progress',
  PROGRESS_BAR: 'progress-bar',
  PROGRESS_COLOR: 'progress-color',
  RANGE_SETTINGS: 'range-settings',
  READONLY: 'readonly',
  READONLY_BACKGROUND: 'readonly-background',
  RECORD_COUNT: 'record-count',
  RELATIVE_BOUNDS: 'relative-bounds',
  REQUIRED: 'required',
  RESET: 'reset',
  RESIZABLE: 'resizable',
  RESIZE_ON_DRAG_END: 'resize-on-drag-end',
  RESPOND_DOWN: 'respond-down',
  RESPOND_UP: 'respond-up',
  RESPONSIVE: 'responsive',
  RESULT: 'result',
  REVEAL: 'reveal',
  REVEAL_ON_EDIT: 'reveal-on-edit',
  REVEALABLE_PASSWORD: 'revealable-password',
  ROW: 'row',
  ROOT_ITEM: 'root-item',
  ROTATE_NAME_LABELS: 'rotate-name-labels',
  ROUND: 'round',
  ROUND_STROKES: 'round-strokes',
  ROUND_TO_INTERVAL: 'round-to-interval',
  ROWS: 'rows',
  ROWS_LG: 'rows-lg',
  ROWS_MD: 'rows-md',
  ROWS_SM: 'rows-sm',
  ROWS_XL: 'rows-xl',
  ROWS_XS: 'rows-xs',
  ROWS_XXL: 'rows-xxl',
  ROW_END: 'row-end',
  ROW_GAP: 'row-gap',
  ROW_HEIGHT: 'row-height',
  ROW_INDEX: 'row-index',
  ROW_NAVIGATION: 'row-navigation',
  ROW_SELECTION: 'row-selection',
  ROWSPAN: 'rowspan',
  ROW_SPAN: 'row-span',
  ROW_SPAN_LG: 'row-span-lg',
  ROW_SPAN_MD: 'row-span-md',
  ROW_SPAN_SM: 'row-span-sm',
  ROW_SPAN_XL: 'row-span-xl',
  ROW_SPAN_XS: 'row-span-xs',
  ROW_SPAN_XXL: 'row-span-xxl',
  ROW_START: 'row-start',
  SAVE_ACTIVE_PAGE: 'save-active-page',
  SAVE_COLUMNS: 'save-columns',
  SAVE_FILTER: 'save-filter',
  SAVE_PAGE_SIZE: 'save-page-size',
  SAVE_POSITION: 'save-position',
  SAVE_ROW_HEIGHT: 'save-row-height',
  SAVE_SORT_ORDER: 'save-sort-order',
  SAVE_USER_SETTINGS: 'save-user-settings',
  SCROLL_MAX_ROWS: 'scroll-max-rows',
  SCROLL_TOP: 'scroll-top',
  SCROLLABLE: 'scrollable',
  SEARCH_FIELD: 'search-field',
  SEARCH_FIELD_ID: 'search-field-id',
  SEARCH_FILTER_MODE: 'search-filter-mode',
  SEARCH_TERM_CASE_SENSITIVE: 'search-term-case-sensitive',
  SEARCH_TERM_MIN_SIZE: 'search-term-min-size',
  SEARCHABLE: 'searchable',
  SEARCHFIELD_PLACEHOLDER: 'searchfield-placeholder',
  SECOND_INTERVAL: 'second-interval',
  SECONDS: 'seconds',
  SELECT: 'select',
  SELECT_ALL: 'select-all',
  SELECTABLE: 'selectable',
  SELECTED: 'selected',
  SELECTION: 'selection',
  SELF_MANAGED: 'self-managed',
  SHADOWED: 'shadowed',
  SHAPE: 'shape',
  SHORTCUT_KEYS: 'shortcut-keys',
  SHOW_ALL: 'show-all',
  SHOW_AXIS_LABELS: 'show-axis-labels',
  SHOW_BROWSE_LINK: 'show-browse-link',
  SHOW_APPLY: 'show-apply',
  SHOW_CANCEL: 'show-cancel',
  SHOW_CHECKBOXES: 'show-checkboxes',
  SHOW_COLON: 'show-colon',
  SHOW_CLEAR: 'show-clear',
  SHOW_CLOSE_BUTTON: 'show-close-button',
  SHOW_CROSSLINES: 'show-crosslines',
  SHOW_DETAILS: 'show-details',
  SHOW_EXPAND_BUTTON: 'show-expand-button',
  SHOW_EXPAND_AND_COLLAPSE_ICONS: 'show-expand-and-collapse-icons',
  SHOW_EXPAND_AND_TOGGLE_ICONS: 'show-expand-and-toggle-icons',
  SHOW_HEADER_EXPANDER: 'show-header-expander',
  SHOW_HORIZONTAL_GRID_LINES: 'show-horizontal-grid-lines',
  SHOW_LABEL: 'show-label',
  SHOW_LEGEND: 'show-legend',
  SHOW_LIST_ITEM_ICON: 'show-list-item-icon',
  SHOW_LOADING_INDICATOR: 'show-loading-indicator',
  SHOW_NO_RESULTS: 'show-no-results',
  SHOW_ON_FOCUS: 'show-on-focus',
  SHOW_PICKLIST_MONTH: 'show-picklist-month',
  SHOW_PICKLIST_WEEK: 'show-picklist-week',
  SHOW_PICKLIST_YEAR: 'show-picklist-year',
  SHOW_TIMELINE: 'show-timeline',
  SHOW_TODAY: 'show-today',
  SHOW_TOOLBAR: 'show-toolbar',
  SHOW_TOOLTIP: 'show-tooltip',
  SHOW_VALUE: 'show-value',
  SHOW_VERTICAL_GRID_LINES: 'show-vertical-grid-lines',
  SHOW_VISITED_COLOR: 'show-visited-color',
  SHOW_WEEK_NUMBERS: 'show-week-numbers',
  SHRINK: 'shrink',
  SIZE: 'size',
  SKIP_SANITIZE: 'skip-sanitize',
  SLIDE_SELECTION: 'slide-selection',
  SLOT: 'slot',
  SORTABLE: 'sortable',
  SOURCE_FORMATTER: 'source-formatter',
  SQUARE: 'square',
  SRC: 'src',
  STACKED: 'stacked',
  STARS: 'stars',
  START: 'start',
  START_DATE: 'start-date',
  START_HOUR: 'start-hour',
  START_LABEL_WIDTH: 'start-label-width',
  STATUS: 'status',
  STATUS_COLOR: 'status-color',
  STEP: 'step',
  STEP_INTERVAL: 'step-interval',
  STEP_NUMBER: 'step-number',
  STEPS_IN_PROGRESS: 'steps-in-progress',
  STYLE: 'style',
  STICKY: 'sticky',
  STICKY_LAYOUT: 'sticky-layout',
  STICKY_POSITION: 'sticky-position',
  STICKY_TOP: 'sticky-top',
  STOPPED: 'stopped',
  STRIP_COL_ID: 'strip-col-id',
  STROKE: 'stroke',
  STROKE_WIDTH: 'stroke-width',
  SUB_TABS: 'sub-tabs',
  SUB_TAB_VALUE: 'sub-tab-value',
  SUBMENU: 'submenu',
  SUBMIT_BUTTON: 'submit-button',
  SUBTITLE: 'subtitle',
  SUPPRESS_CACHING: 'suppress-caching',
  SUPPRESS_ERROR_MESSAGE: 'suppress-error-message',
  SUPPRESS_VALIDATION: 'suppress-validation',
  SUPPRESS_CONTROLS: 'suppress-controls',
  SUPPRESS_DEACTIVATION: 'suppress-deactivation',
  SUPPRESS_DESELECTION: 'suppress-deselection',
  SUPPRESS_EMPTY_MESSAGE: 'suppress-empty-message',
  SUPPRESS_FORM: 'suppress-form',
  SUPPRESS_HIGHLIGHT: 'suppress-highlight',
  SUPPRESS_LABELS: 'suppress-labels',
  SUPPRESS_ROW_CLICK_SELECTION: 'suppress-row-click-selection',
  SUPPRESS_ROW_DEACTIVATION: 'suppress-row-deactivation',
  SUPPRESS_ROW_DESELECTION: 'suppress-row-deselection',
  SUPPRESS_SELECT_ALL_EVENTS: 'suppress-select-all-events',
  SUPPRESS_TOOLTIPS: 'suppress-tooltips',
  SUPPRESS_ENTER_KEY: 'suppress-enter-key',
  SWAPPABLE: 'swappable',
  SWATCH: 'swatch',
  SWIPE_TYPE: 'swipe-type',
  TABBABLE: 'tabbable',
  TABINDEX: 'tabindex',
  TABS: 'tabs',
  TAGS: 'tags',
  TAG_COLOR: 'tag-color',
  TARGET: 'target',
  TEMPLATE_ROWS: 'template-rows',
  TEXT: 'text',
  TEXT_ALIGN: 'text-align',
  TEXT_COLOR: 'text-color',
  TEXT_DECORATION: 'text-decoration',
  TEXT_DISPLAY: 'text-display',
  TEXT_ELLIPSIS: 'text-ellipsis',
  TEXT_OFF: 'text-off',
  TEXT_ON: 'text-on',
  TEXT_SEARCH_TYPE: 'text-search-type',
  TEXT_WRAP: 'text-wrap',
  THEME: 'theme',
  TICKS: 'ticks',
  TIMELINE_INTERVAL: 'timeline-interval',
  TIMEOUT: 'timeout',
  TITLE: 'title',
  TODAY_SHORTCUT: 'today-shortcut',
  TOGGLE_COLLAPSE_ICON: 'toggle-collapse-icon',
  TOGGLE_EXPAND_ICON: 'toggle-expand-icon',
  TOGGLE_ON_ICON: 'toggle-on-icon',
  TOGGLE_ICON_ROTATE: 'toggle-icon-rotate',
  TOGGLEABLE: 'toggleable',
  TOOLBAR_TYPE: 'toolbar-type',
  CONTEXTUAL_TOOLBAR_ID: 'contextual-toolbar-id',
  TOOLTIP: 'tooltip',
  TOOLTIP_PLACEMENT: 'tooltip-placement',
  TOOLTIP_PLAIN_TEXT: 'tooltip-plain-text',
  TOP: 'top',
  TOTAL: 'total',
  TRANSLATE_TEXT: 'translate-text',
  TRANSLATION_KEY: 'translation-key',
  TRANSLATION_PARAMS: 'translation-params',
  TREE_GRID: 'tree-grid',
  TREND: 'trend',
  TREND_LABEL: 'trend-label',
  TREND_LABEL_COLOR: 'trend-label-color',
  TREND_LABEL_ICON_COLOR: 'trend-label-icon-color',
  TREND_LABEL_NO_ICON: 'trend-label-no-icon',
  TREND_FORMAT: 'trend-format',
  TRIGGER: 'trigger',
  TRIGGER_ELEM: 'trigger-elem',
  TRIGGER_LABEL: 'trigger-label',
  TRIGGER_TYPE: 'trigger-type',
  TRIGGERFIELD: 'triggerfield',
  TRUNCATE: 'truncate',
  TRUNCATED: 'truncated',
  TYPE: 'type',
  TYPEAHEAD: 'typeahead',
  UNIQUE_ID: 'unique-id',
  UPPERCASE: 'uppercase',
  URL: 'url',
  USE_CURRENT_TIME: 'use-current-time',
  USE_DEFAULT_COPYRIGHT: 'use-default-copyright',
  USE_LOG_SCALE: 'use-log-scale',
  USE_RANGE: 'use-range',
  USE_UTC: 'use-utc',
  USER_STATUS: 'user-status',
  UTC_DATE_VALUE: 'utc-date-value',
  VALIDATE: 'validate',
  VALIDATION_EVENTS: 'validation-events',
  VALIDATION_HAS_ERROR: 'validation-has-error',
  VALIDATION_ICON: 'validation-icon',
  VALIDATION_ID: 'validation-id',
  VALIDATION_MESSAGE: 'validation-message',
  VALIDATION_TYPE: 'validation-type',
  VALUE_FIELD: 'value-field',
  VALUE_SECONDARY: 'value-secondary',
  VALUE: 'value',
  VERTICAL: 'vertical',
  VIEW: 'view',
  VIEW_PICKER: 'view-picker',
  VIEWBOX: 'viewbox',
  VIRTUAL_SCROLL: 'virtual-scroll',
  VISIBLE: 'visible',
  WAIT_FOR_CONTENT: 'wait-for-content',
  WIDGET_HEIGHT: 'widget-height',
  WIDGET_WIDTH: 'widget-width',
  WIDTH: 'width',
  WORD_BREAK: 'word-break',
  WORD_WRAP: 'word-wrap',
  WRAP: 'wrap',
  WRAP_WIDTH: 'wrap-width',
  X: 'x',
  X_AXIS_FORMATTER: 'x-axis-formatter',
  X_AXIS_MIN: 'x-axis-min',
  X_OFFSET: 'x-offset',
  XSS_IGNORED_TAGS: 'xss-ignored-tags',
  Y: 'y',
  Y_AXIS_FORMATTER: 'y-axis-formatter',
  Y_AXIS_MIN: 'y-axis-min',
  Y_OFFSET: 'y-offset',
  YEAR: 'year',
  Z_INDEX: 'z-index',
  USE_FORMATTERS_FOR_SIZING: 'use-formatters-for-sizing',
  WHITE_SPACE: 'white-space'
};

// Standard HTMLElement attribute names
// Please keep constants alphabetized
export const htmlAttributes = {
  ARIA_ACTIVE_DESCENDANT: 'aria-activedescendant',
  ARIA_ATOMIC: 'aria-atomic',
  ARIA_CHECKED: 'aria-checked',
  ARIA_CONTROLS: 'aria-controls',
  ARIA_COLINDEX: 'aria-colindex',
  ARIA_DESCRIBED_BY: 'aria-describedby',
  ARIA_DISABLED: 'aria-disabled',
  ARIA_EXPANDED: 'aria-expanded',
  ARIA_HASPOPUP: 'aria-haspopup',
  ARIA_HIDDEN: 'aria-hidden',
  ARIA_INVALID: 'aria-invalid',
  ARIA_LABEL: 'aria-label',
  ARIA_LABELLED_BY: 'aria-labelledby',
  ARIA_LEVEL: 'aria-level',
  ARIA_LIVE: 'aria-live',
  ARIA_MULTISELECTABLE: 'aria-multiselectable',
  ARIA_ORIENTATION: 'aria-orientation',
  ARIA_OWNS: 'aria-owns',
  ARIA_POSINSET: 'aria-posinset',
  ARIA_READONLY: 'aria-readonly',
  ARIA_SELECTED: 'aria-selected',
  ARIA_SETSIZE: 'aria-setsize',
  ARIA_VALUEMAX: 'aria-valuemax',
  ARIA_VALUEMIN: 'aria-valuemin',
  ARIA_VALUENOW: 'aria-valuenow',
  ARIA_VALUETEXT: 'aria-valuetext',
  CONTENTEDITABLE: 'contenteditable',
  HIDDEN: 'hidden',
  ICON: 'icon',
  ROLE: 'role',
  SLOT: 'slot',
  TABINDEX: 'tabIndex'
};

export const prefix = {
  PREFIX: 'ids'
};

export const version = '1.16.24';

export enum IdsDirection {
  Up = 'up',
  Down = 'down',
  Left = 'left',
  Right = 'right',
  Next = 'next',
  Previous = 'previous'
}
